import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { miloCore, Cdk } from '@tencent/milo-core';
import { miloAlert } from '../AlertDialog';
import { bindArea } from '../AreaBind/areabind';
import { selectRole } from '../RoleSelector/roleselector';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile';
import request from '../api';
var exchangeCdk = Cdk.exchangeCdk.bind(Cdk);
var activateCdk = Cdk.activateCdk.bind(Cdk);
var verifyBaseUrl = 'https://ssl.captcha.qq.com/getimage?aid=21000104'; // 验证码地址

var CDKComp = /*#__PURE__*/function () {
  function CDKComp(opt) {
    _classCallCheck(this, CDKComp);

    this.option = _objectSpread({
      iActivityId: '',
      // 活动的ID
      iFlowId: '',
      flowConfig: {
        sData: null,
        // 用于用户主动传递内嵌角色信息
        withRoleInfo: false
      },
      extendRole: {},
      type: '1',
      // 1: exchangeCdk; 2: activateCdk
      withAreaInfo: false,
      // 角色信息是否来自内嵌大区
      needVerifyCode: false,
      contentId: 'cdkeyValue',
      // 容器ID
      verifyImgId: null,
      // 验证码图片id
      verifyChangeBtn: null,
      // 切换验证码图片按钮id
      verifyCodeId: null,
      // 验证码输入框id,
      onSuccess: null,
      onFail: null
    }, opt);
    this.platform = opt.platform || (miloCore.platform.isMobile() ? 'mobile' : 'pc'); // 绑定刷新图片事件

    this.bindEvents(this.option.verifyImgId, this.option.verifyChangeBtn);
  }

  _createClass(CDKComp, [{
    key: "bindEvents",
    value: function bindEvents(VerifyImgId, verifyChangeBtn) {
      if (!this.option.verifyChangeBtn) {
        return;
      }

      var img = document.getElementById(VerifyImgId);
      var changeVerifyImgBtn = document.getElementById(verifyChangeBtn);
      changeVerifyImgBtn.addEventListener('click', function () {
        img.src = "".concat(verifyBaseUrl).concat(Math.ceil(1000000 * Math.random()));
      }, false);
      var curSrc = img.getAttribute('src'); // 初始化验证码[兼容https]

      if (!curSrc || curSrc.indexOf('https://ssl.captcha.qq.com') == -1) {
        img.src = "".concat(verifyBaseUrl).concat(Math.ceil(1000000 * Math.random()));
      }
    }
  }, {
    key: "refreshVerifyCode",
    value: function refreshVerifyCode() {
      if (!this.option.verifyImgId) {
        return;
      }

      var img = document.getElementById(this.option.verifyImgId);

      if (!img) {
        return;
      }

      img.src = "".concat(verifyBaseUrl).concat(Math.ceil(1000000 * Math.random()));
    }
  }, {
    key: "submit",
    value: function submit(role, rsOption) {
      var _this = this;

      var self = this;
      var sCdKey = document.getElementById(this.option.contentId).value || '';
      sCdKey = sCdKey.replace(/^\s+|\s+$/g, '');
      var sVerifyImg = document.getElementById(this.option.verifyCodeId);
      var sVerifyCode = '';

      if (sVerifyImg) {
        this.option.needVerifyCode = true;
        sVerifyCode = sVerifyImg && sVerifyImg.value || '';
      }

      var _ref = this.option.flowConfig || {},
          sData = _ref.sData;

      sData = _objectSpread(_objectSpread({}, sData), {}, {
        sCdKey: sCdKey,
        sVerifyCode: sVerifyCode,
        needVerifyCode: this.option.needVerifyCode
      });

      if (this.option.type == '1' && this.option.withAreaInfo) {
        // 内嵌大区兑换CDK流程
        if (!role) {
          miloAlert('请首先选择角色信息');
          return;
        }

        this.option.flowConfig.withRoleInfo = true;
        sData = _objectSpread(_objectSpread({}, sData), {}, {
          sServiceType: rsOption.gameId,
          sArea: role.area,
          sPartition: role.partition,
          sRoleId: role.roleId,
          sAreaName: role.areaName,
          sRoleName: role.roleName,
          md5str: role.md5str,
          iSex: role.roleSex || '',
          sPlatId: role.platid,
          ams_checkparam: role.checkparam,
          checkparam: role.checkparam
        });
      }

      this.option.flowConfig.sData = sData;
      var requestFun = this.option.type == '2' ? activateCdk : exchangeCdk;
      request(requestFun, this.option).then(function (res) {
        if (res.iRet == 0) {
          if (_this.option.onSuccess) {
            _this.option.onSuccess(res);
          } else {
            miloAlert('兑换成功');
          }
        } else {
          if (_this.option.onFail) {
            _this.option.onFail(res);
          } else {
            miloAlert(res.errMsg || res.sMsg || res.msg);
          }
        }

        _this.refreshVerifyCode();

        if (_this.option.type == '1' && _this.option.withAreaInfo) {
          return;
        }

        if (_this.option.flowConfig && _this.option.flowConfig.sData) {
          _this.option.flowConfig.sData.sRoleId = ''; // 清空角色信息，确保每次提交前都需要选择角色
        }
      })["catch"](function (err) {
        var errCode = err.errCode;

        if (errCode === 3) {
          // 需要首先选择角色
          var selectRoleFn = _this.platform === 'mobile' ? selectRoleMobile : selectRole;

          var rsConfig = _objectSpread(_objectSpread(_objectSpread({}, err.rsOption), self.option.extendRole), {}, {
            onSubmit: function onSubmit(role) {
              _this.submit(role, err.rsOption);
            },
            onError: function onError(err) {
              _this.refreshVerifyCode();

              if (err && err.errCode && parseInt(err.errCode) === -1) {
                // 登陆错误统一处理
                if (_this.option.type == '1' && _this.option.withAreaInfo) {
                  return;
                }

                if (_this.option.flowConfig && _this.option.flowConfig.sData) {
                  _this.option.flowConfig.sData.sRoleId = '';
                }

                return;
              }

              if (_this.option.onFail) {
                _this.option.onFail(err);
              } else {
                miloAlert(err.errMsg || err.msg || err.sMsg);
              }

              if (_this.option.type == '1' && _this.option.withAreaInfo) {
                return;
              }

              if (_this.option.flowConfig && _this.option.flowConfig.sData) {
                _this.option.flowConfig.sData.sRoleId = '';
              }
            }
          });

          selectRoleFn(rsConfig);
        } else if (errCode === 2) {
          bindArea({
            bindOptions: _objectSpread(_objectSpread({}, err.areaBindOption), {}, {
              flowConfig: _objectSpread({}, self.option.extendRole),
              onSuccess: function onSuccess() {
                _this.submit();
              },
              onFail: function onFail(err) {
                if (err && err.errCode && parseInt(err.errCode) === -1) {
                  // 登陆错误统一处理
                  return;
                }

                if (_this.option.onFail) {
                  _this.option.onFail(err);
                } else {
                  miloAlert('网络超时，请稍后重试');
                }
              }
            })
          });
        } else if (errCode == -1) {
          // 未登录
          _this.refreshVerifyCode();

          if (_this.option.type == '1' && _this.option.withAreaInfo) {
            return;
          }

          if (_this.option.flowConfig && _this.option.flowConfig.sData) {
            _this.option.flowConfig.sData.sRoleId = '';
          }
        } else {
          _this.refreshVerifyCode();

          if (err && err.errCode && parseInt(err.errCode) === -1) {
            // 登陆错误统一处理
            if (_this.option.type == '1' && _this.option.withAreaInfo) {
              return;
            }

            if (_this.option.flowConfig && _this.option.flowConfig.sData) {
              _this.option.flowConfig.sData.sRoleId = '';
            }

            return;
          }

          if (_this.option.onFail) {
            _this.option.onFail(err);
          } else {
            miloAlert(err.errMsg || err.msg || err.sMsg);
          }

          if (_this.option.type == '1' && _this.option.withAreaInfo) {
            return;
          }

          if (_this.option.flowConfig && _this.option.flowConfig.sData) {
            _this.option.flowConfig.sData.sRoleId = '';
          }
        }
      });
    }
  }]);

  return CDKComp;
}();

export { CDKComp as default };
export var CDK = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new CDKComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: 'cdk初始化失败'
        });
      }
    });
  }
};